import { Button } from "@mui/material";


// Style applied to all buttons regardless of selected state
const baseStyle = {
    marginRight: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
    marginBottom: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
    textTransform: "none",
    borderRadius: 0,
    fontSize: { xs: 17, sm: 17, md: 18, lg: 19, xl: 16 },
    width: { xs: "20%", sm: "20%", md: "20%", lg: "20%", xl: "20%" },
};

const DocumentFilterButton = ({ id, title, applyFilter, isSelected }) => {

    const selected = isSelected === title ? true : false

    function changeSelectedState(value) {
        applyFilter(title);
    }
    // Conditional style based on selected state
    const selectedStyle = selected
        ? {
            backgroundColor: "primary.dark",
            color: "white",
            borderColor: "primary.dark",
            "&:hover": {
                color: "primary.dark",
                backgroundColor: "primary.light",
                borderColor: "primary.light",
            },
        }
        : {
            color: "primary.dark",
            borderColor: "primary.dark",
            "&:hover": {
                backgroundColor: "primary.light",
                borderColor: "primary.light",
            },
        };

    return (
        <Button
            id={id}
            onClick={() =>
                changeSelectedState(selected)
            }
            variant='outlined'
            sx={{
                backgroundColor: "#FFF",
                ...baseStyle,
                ...selectedStyle,
            }}
        >
            {title}
        </Button>
    )
};

export default DocumentFilterButton;